// extracted by mini-css-extract-plugin
export default {"card":"TeamAcceptCard_card__ayTtY"};